import type { MediaFile, MediaFileCreate, MediaFileId } from '../schema';

import { db } from '..';
import { generatedUUID } from '../utils';

export async function createMediaFile(
    mediaFile: MediaFileCreate,
): Promise<MediaFile> {
    const newMediaFile: MediaFile = {
        ...mediaFile,
        mediaFileId: mediaFile.mediaFileId ?? generatedUUID<MediaFileId>(),
        syncStatus: 'queued',
        localCreatedAt: Date.now(),
        localUpdatedAt: Date.now(),
    };

    await db.mediaFiles.put(newMediaFile);

    return newMediaFile;
}

export async function getMediaFile(
    id: MediaFileId,
): Promise<MediaFile | undefined> {
    return db.mediaFiles.get(id);
}

export async function getAllMediaFiles(): Promise<MediaFile[]> {
    return db.mediaFiles.toArray();
}

export async function updateMediaFile(
    id: MediaFileId,
    mediaFile: Partial<MediaFile>,
): Promise<void> {
    await db.mediaFiles.update(id, mediaFile);
}

export async function deleteMediaFile(id: MediaFileId): Promise<void> {
    await db.mediaFiles.delete(id);
}

export async function deleteAllMediaFiles(): Promise<void> {
    await db.mediaFiles.clear();
}
